import React from "react";
import "../Navigation/css/NavBar.scss";
import {Black} from "../../theme/styles";
import ReactJson from "react-json-view";
import authenticate_get_response from "../../json/authenticate/authenticate-get-response.json";


export default function AuthenticateGET() {

    return (
        <div style={{paddingLeft: "20px", paddingRight: "30px"}}>
            <p style={{fontSize: "24px", fontWeight: "400", color: Black}}>Authenticate GET</p>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Overview</p>

            <p style={{fontSize: "14px", fontWeight: "400", color: Black, marginLeft: "20px"}}>
                The GET action is the first step in the authentication process.
            </p>
            <br/>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Parameters</p>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px"}}>Basic Query Parameters
                    <li style={{marginTop: "20px", marginLeft: "20px"}}>type=preauth (Required String)</li>
                </li>
            </ul>
            <br/>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Example</p>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                A typical GET execution will look as follows.<br/><br/>
                <span style={{fontFamily: "Courier New", fontSize: "14px",}}>curl -G -d "type=preauth" "https://api.integrate.enlil.io/t3/v1/authenticate"</span><br/><br/>
                It will respond with a payload similar to the following.<br/><br/>
                <p style={{fontFamily: "Courier New", fontSize: "12px"}}>
                    <ReactJson src={authenticate_get_response} collapseStringsAfterLength={75} collapsed={4}/>
                </p>
                <br/>
                The X-Enlil-AccessToken will be required as a header in the authenticate POST action.
            </ul>
            <br/>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Error Codes</p>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px"}}>400 CC-CA62-4B92 - Invalid query parameter: Type</li>
            </ul>
            <br/>
        </div>
    )
}